/**
 * Note: Same as PortalTypeEnum for SAPortal.Api with [Flags] attribute
 * WARNING: Must be equal to BusinessType on WebAPI model
 */
export enum PortalTypeEnum {
    NotSet = 0,
    Train = 1,
    Bus = 2,
}


export class LoginModel {

    constructor(
        public Username: string,

        public Password: string,

        public RememberMe: boolean,

        public PortalType: PortalTypeEnum
    ) {
    }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/login/login.model.ts